<div class="inner-content" ridangoAppTrapFocus>
    <div class="relative flex h-16 w-full items-center overflow-y-auto align-middle">
        <div class="w-full text-center text-base" [attr.aria-description]="foundResultsAriaDescription">
            <p class="font-semibold" *ngIf="modalType === 'ROUTE'">{{ 'CHOOSE_LINES' | translate }}</p>
            <p class="font-semibold" *ngIf="modalType === 'CATEGORY'">{{ 'CHOOSE_CATEGORIES' | translate }}</p>
            <p class="font-semibold" *ngIf="modalType === 'DIRECTION'">
                {{ 'SCHEDULE_ROUTE_DIRECTION_SELECTION_TITLE' | translate }}
            </p>
        </div>

        <ng-container *ngIf="isVastmanlandApp; else generalCloseIcon">
            <ion-icon
                class="vl-app-light:filter-none filter-black absolute right-0 cursor-pointer pr-3 text-sm dark:filter-yellow"
                [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate"
                (click)="cancel()"
                src="{{ assetsPath$ | async }}/img/close.svg">
            </ion-icon>
        </ng-container>

        <ng-template #generalCloseIcon>
            <div class="vl-app-light:filter-none filter-black absolute right-0 text-sm dark:filter-yellow">
                <button [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate" (click)="cancel()" mat-icon-button>
                    <mat-icon aria-hidden="true">close</mat-icon>
                </button>
            </div>
        </ng-template>
    </div>

    <ion-item
        class="search-input mb-4"
        *ngIf="modalType === disruptionMessagesModalType.ROUTE"
        color="light"
        lines="none"
        detail="false">
        <ion-input
            class="text-base"
            #input
            (input)="filterOptions($event)"
            (click)="onSearchFieldClick()"
            placeholder=" {{ 'HEADER_SEARCH_HOME' | translate }}&nbsp;"></ion-input>
        <ng-container *ngIf="isVastmanlandApp; else generalSearchIcon">
            <ion-icon
                class="text-old_silver text-sm dark:text-contrast-black"
                aria-hidden="true"
                src="{{ assetsPath$ | async }}/img/search.svg">
            </ion-icon>
        </ng-container>
        <ng-template #generalSearchIcon>
            <ion-icon
                class="text-old_silver dark:text-contrast-black"
                aria-hidden="true"
                name="search-outline"></ion-icon>
        </ng-template>
    </ion-item>

    <ul class="checkbox-items mb-0 max-h-40 overflow-y-auto">
        <li
            *ngFor="let option of checkboxKeys; let i = index"
            [attr.aria-posinset]="i + 1"
            [attr.aria-setsize]="checkboxKeys.length">
            <ion-item
                class="checkbox-item text-base"
                [attr.aria-checked]="checkboxValues[option]"
                [ngClass]="{ bold: checkboxValues[option] }"
                (click)="toggle($event, option)"
                mode="md"
                role="checkbox"
                tabindex="0"
                lines="none">
                <ion-label *ngIf="modalType === 'CATEGORY'">{{ option | translate }}</ion-label>
                <ion-label *ngIf="modalType === 'DIRECTION'">{{ option }}</ion-label>
                <ion-label *ngIf="modalType === 'ROUTE'">
                    <ng-container *ngIf="option?.length > 5 && option.constructor === String">
                        {{ 'LINE' | translate }}
                    </ng-container>
                    {{ option }}</ion-label
                >
                <ion-checkbox
                    class="size-4"
                    [checked]="checkboxValues[option]"
                    (ionChange)="checkIsAllSelect()"
                    mode="md"
                    aria-hidden="true"
                    role="checkbox"
                    tabindex="-1"
                    slot="start"
                    name="{{ option }}"></ion-checkbox>
            </ion-item>
        </li>
    </ul>

    <div class="flex flex-col justify-center border-t border-solid border-opacity-10 dark:border-contrast-yellow">
        <ion-button
            class="my-0 h-16 text-base font-medium normal-case text-secondary dark:text-contrast-yellow"
            *ngIf="allChecked"
            [attr.aria-label]="'DESELECT_ALL' | translate"
            (click)="toggleSelectAll()"
            fill="clear">
            {{ 'DESELECT_ALL' | translate }}
        </ion-button>
        <ion-button
            class="my-0 h-16 text-base font-medium normal-case text-secondary dark:text-contrast-yellow"
            *ngIf="!allChecked"
            [attr.aria-label]="'SELECT_ALL' | translate"
            (click)="toggleSelectAll()"
            fill="clear">
            {{ 'SELECT_ALL' | translate }}
        </ion-button>

        <div class="cdk-visually-hidden" *ngIf="allChecked !== null" aria-live="polite" aria-atomic="true">
            {{ allChecked ? ('ALL_ITEMS_WERE_SELECTED' | translate) : ('ALL_ITEMS_WERE_DESELECTED' | translate) }}
        </div>

        <ion-button
            class="vl-app-light:bg-secondary-button vl-app-light:text-black vl-app-light-dark:mt-0 sr-app-light-dark:mt-0 my-0 h-16 w-full rounded-lg bg-secondary text-base font-medium normal-case tracking-normal text-white dark:bg-contrast-yellow dark:text-contrast-black"
            [attr.aria-label]="'CHOOSE' | translate"
            (click)="confirm()"
            fill="clear">
            {{ 'CHOOSE' | translate }}
        </ion-button>
    </div>
</div>
